import { Autocomplete, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext'
import { campaignExecutionStatusData, contactTagFilterInterface, createCampaignResponse, createWhatsappTemplatePayload, getTemplateDetails, retargetCampaignpayload } from '../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import style from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import CloseIcon from '@mui/icons-material/Close';
import previewIcon from '../../../assets/chatbotAssets/Chatbot-Preview-Arrow.svg'
import GlobalButton from '../../utility/globalButton/button';
import BasicTemplatePreview from '../channels/global/whatsapp/templates/previews/basicTemplatePreview';
import { defaultCreateTemplatePayload } from './whatsappCampaign';
import Required from '../../utility/required';
import { defaultRetargetCampaignPayload, filteredRetargetContacts } from './campaignConstant';
import { ContactContext, ContactContextPayload } from '../../../context/contactContext';
import { useNavigate } from 'react-router-dom';
import { allowedExecutionContactStatus } from './utils';
import IconsColor from '../../utility/iconsColor';
import GlobalPopUp from '../../utility/globalPopUp';
import RetargetedContactTable from './retargetedContactTable';
import { primaryColor } from '../../../utils/colors';
import { useTemplateLibraryStore } from '../../../store/templateLibraryStore';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface RetargetDrawerProps {
    selectedCampaign: createCampaignResponse,
    setOpenRetargetDrawer: React.Dispatch<React.SetStateAction<boolean>>,
}

const RetargetDrawer: React.FC<RetargetDrawerProps> = (props) => {

    const { selectedCampaign, setOpenRetargetDrawer } = props;
    const { getCampaignDataApi, selectedWhatsAppCampaign, setSelectedWhatsAppCampaign, getWhatsappTemplateDetailsApiCall, messageTemplateDetail, getCampaignContactFilterTypeApi, getCampaignExecutionStatusApi, campaignContactFilterTypeData, campaignExecutionStatusData, createCampaignApi } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;
    const { getCampaignContactApi } = useContext(ContactContext) as ContactContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const templateCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [createTemplatePayload, setCreateTemplatePayload] = useState<createWhatsappTemplatePayload>(defaultCreateTemplatePayload(templateCategoryList ?? []));
    const [retargetCampaignPayload, setRetargetCampaignPayload] = useState<retargetCampaignpayload>(defaultRetargetCampaignPayload(selectedCampaign?.campaign_id, selectedCampaign?.contact_list_id, selectedCampaign?.meta_integration_whatsapp_phone_number_id));

    const breakPoints = {
        flagLaptopScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1200px)'),
        flagLargeScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1200px)'),
        flagMobileScreen: useMediaQuery('(max-width : 600px) and (min-width : 0px)'),
        flagBetweenMobileTabletScreen: useMediaQuery('(max-width : 760px) and (min-width : 600px)'),
        flagTabletScreen: useMediaQuery('(max-width : 768px) and (min-width : 0px)')
    }
    const innerHeight = breakPoints.flagMobileScreen ? (window.innerHeight - 185) : breakPoints.flagBetweenMobileTabletScreen ? (window.innerHeight - 180) : (window.innerHeight - 175);
    const navigate = useNavigate();
    const [flagContactListDialog, setFlagContactListDialog] = useState<boolean>(false);
    const [filteredExecutionStatusContacts, setFilteredExecutionStatusContacts] = useState<any>(null);

    const getCampaignDataApiCall = async (campaign_id: number) => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await getCampaignDataApi(campaign_id);
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    const getWhatsappTemplateDetailsApi = async (meta_integration_whatsapp_id: number, whatsapp_template_id: number) => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await getWhatsappTemplateDetailsApiCall(meta_integration_whatsapp_id, whatsapp_template_id);
        if (!(res.status)) {
            handleError(res);
        } else {
            //@ts-ignore
            const updatedTemplatePayloadValue: createWhatsappTemplatePayload = updateValueOfCreateTemplatePayload(res.data[0]);
            setCreateTemplatePayload(updatedTemplatePayloadValue);
        }
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    const getCampaignContactFilterTypeApiCall = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await getCampaignContactFilterTypeApi();
        if (!(res.status)) {
            handleError(res);
        }
        setRetargetCampaignPayload((prevState) => ({
            ...prevState,
            campaign_contact_filter: [{
                campaign_contact_filter_type_id: res.data?.find((filter) => filter.campaign_contact_filter_type_name.toLowerCase() == "campaign execution status")?.campaign_contact_filter_type_id || 1,
                campaign_contact_filter_type_name: "Campaign Execution Status",
                campaign_contact_filter_type_data: [],
            }]
        }))
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    const getCampaignExecutionStatusApiCall = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await getCampaignExecutionStatusApi();
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    const getCampaignContactApiCall = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true, flagFullScreenLoader: true }));

        const payload = {
            contact_list_id: selectedCampaign?.contact_list_id,
        }

        const res = await getCampaignContactApi(payload);
        if (!(res.status)) {
            handleError(res);
        }

        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false, flagFullScreenLoader: false }));
    }

    const updateValueOfCreateTemplatePayload = (messageTemplateDetail: getTemplateDetails) => {
        return {
            "whatsapp_template_id": messageTemplateDetail.whatsapp_template_id,
            "meta_integration_whatsapp_id": messageTemplateDetail.meta_integration_whatsapp_id, 
            "interactive_type_id": messageTemplateDetail?.interactive_type?.interactive_type_id ?? null,
            "whatsapp_template_data": {
                "whatsapp_template_data_id": null,
                "whatsapp_template_category_id": Number(messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_category_id ?? 0),
                "whatsapp_language_id": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_language_data?.whatsapp_language_id ?? null,
                "whatsapp_template_name": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_name ?? "",
                "whatsapp_template_description": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_description ?? "",
                "whatsapp_template_button": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_button?.map((button) => ({
                    "whatsapp_template_button_type_id": Number(button.whatsapp_template_button_type_id),
                    "whatsapp_template_button_id": button.whatsapp_template_button_id ?? null,
                    "whatsapp_template_button_index": button.whatsapp_template_button_index,
                    "whatsapp_template_button_data": button.whatsapp_template_button_data?.map((buttonData) => ({
                        ...buttonData,
                        "whatsapp_template_button_sub_type_field_data": buttonData.whatsapp_template_button_sub_type_field_data?.map((subField) => ({
                            ...subField,
                            "whatsapp_template_button_field_data_variable": subField.whatsapp_template_button_field_data_variable ?? null,
                        })),
                    })),
                })) ?? [],
                "whatsapp_template_header": {
                    "whatsapp_template_header_type_id": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_type_id ?? null,
                    "whatsapp_template_header_type_name": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_type_name ?? "",
                    "whatsapp_template_header_data": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_header?.whatsapp_template_header_data?.flatMap((header) => {
                        return {
                            "whatsapp_template_header_data_value": header.whatsapp_template_header_data_value,
                            "whatsapp_template_header_data_id": header.whatsapp_template_header_data_id,
                            "whatsapp_template_header_data_google_storage_id": header.whatsapp_template_header_data_google_storage_id,
                            "whatsapp_template_header_variable_data": header.whatsapp_template_header_variable_data?.flatMap((hVariable) => ({
                                "whatsapp_template_dynamic_variable_id": hVariable?.whatsapp_template_dynamic_variable_id,
                                "whatsapp_template_dynamic_variable_type_id": hVariable?.whatsapp_template_dynamic_variable_type_id,
                                "whatsapp_template_dynamic_variable_unique_id": hVariable?.whatsapp_template_dynamic_variable_unique_id,
                                "whatsapp_template_dynamic_variable_key": hVariable?.whatsapp_template_dynamic_variable_key,
                                "whatsapp_template_dynamic_variable_sample_value": hVariable?.whatsapp_template_dynamic_variable_sample_value,
                                "flag_header": hVariable?.flag_header,
                                "flag_button": hVariable?.flag_button,
                                "whatsapp_template_dynamic_variable_type_name": hVariable?.whatsapp_template_dynamic_variable_type_name
                            })) ?? []
                        }
                    }) ?? []
                },
                "whatsapp_template_body": {
                    "whatsapp_template_body_value": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body?.whatsapp_template_body_value ?? "",
                    "whatsapp_template_body_description": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body?.whatsapp_template_body_description ?? "",
                    "whatsapp_template_body_variable_data": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_body?.whatsapp_template_body_variable_data?.flatMap((variable) => {
                        return {
                            "whatsapp_template_dynamic_variable_id": variable?.whatsapp_template_dynamic_variable_id,
                            "whatsapp_template_dynamic_variable_type_id": variable?.whatsapp_template_dynamic_variable_type_id,
                            "whatsapp_template_dynamic_variable_unique_id": variable?.whatsapp_template_dynamic_variable_unique_id,
                            "whatsapp_template_dynamic_variable_key": variable?.whatsapp_template_dynamic_variable_key,
                            "whatsapp_template_dynamic_variable_sample_value": variable?.whatsapp_template_dynamic_variable_sample_value,
                            "flag_header": variable?.flag_header,
                            "flag_button": variable?.flag_button,
                            "whatsapp_template_dynamic_variable_type_name": variable?.whatsapp_template_dynamic_variable_type_name
                        };
                    }) ?? []
                },
                "whatsapp_template_footer": {
                    "whatsapp_template_footer_id": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_footer?.whatsapp_template_footer_id,
                    "whatsapp_template_footer_value": messageTemplateDetail.whatsapp_template_data?.[0].whatsapp_template_footer?.whatsapp_template_footer_value
                }
            }
        };
    }

    useEffect(() => {
        getCampaignContactApiCall()
        if (!selectedWhatsAppCampaign || (selectedCampaign?.campaign_id != selectedWhatsAppCampaign?.campaign_id)) {
            getCampaignDataApiCall(selectedCampaign?.campaign_id);
        }
        if (!messageTemplateDetail || messageTemplateDetail.whatsapp_template_id != selectedCampaign?.whatsapp_template_id) {
            getWhatsappTemplateDetailsApi(selectedCampaign?.meta_integration_whatsapp_id, selectedCampaign?.whatsapp_template_id);
        } else {
            //@ts-ignore
            const updatedTemplatePayloadValue: createWhatsappTemplatePayload = updateValueOfCreateTemplatePayload(messageTemplateDetail);
            setCreateTemplatePayload(updatedTemplatePayloadValue);
        }

        if (!campaignContactFilterTypeData) {
            getCampaignContactFilterTypeApiCall();
        } else {
            setRetargetCampaignPayload((prevState) => ({
                ...prevState,
                campaign_contact_filter: [{
                    campaign_contact_filter_type_id: campaignContactFilterTypeData.find((filter) => filter.campaign_contact_filter_type_name.toLowerCase() == "campaign execution status")?.campaign_contact_filter_type_id || 1,
                    campaign_contact_filter_type_name: "Campaign Execution Status",
                    campaign_contact_filter_type_data: [],
                }]
            }))
        }

        setRetargetCampaignPayload((prevState) => ({
            ...prevState,
            campaign_title: `${selectedCampaign?.campaign_title ? `Follow Up Campaign for ${selectedCampaign?.campaign_title}` : ""}`,
        }));

        if (!campaignExecutionStatusData) {
            getCampaignExecutionStatusApiCall();
        }
    }, [])

    const onChangeOfExecutionStatus = (value: campaignExecutionStatusData[]) => {
        const updatedValue = value.map((status: campaignExecutionStatusData) => {
            return ({
                campaign_contact_filter_unique_id: status.campaign_execution_status_id,
                campaign_contact_filter_unique_value: [], // Always Empty Array.
            })
        }) || [];

        setRetargetCampaignPayload((prevState) => ({
            ...prevState,
            campaign_contact_filter: prevState.campaign_contact_filter.map((filter) => {
                if (filter.campaign_contact_filter_type_name.toLowerCase() == "campaign execution status") {
                    filter.campaign_contact_filter_type_data = updatedValue;
                }
                return filter;
            })
        }));
    }

    const checkDisableCreateButton = () => {
        if (retargetCampaignPayload.campaign_title.trim()?.length > 0 && retargetCampaignPayload?.campaign_contact_filter_logic_operator?.length > 0 && retargetCampaignPayload?.retargeted_from_campaign_id && retargetCampaignPayload?.campaign_contact_filter?.every((filter) => filter.campaign_contact_filter_type_data?.length > 0)) {
            if (filteredExecutionStatusContacts?.length > 0) {
                return false;
            }
        }
        return true;
    }

    const handleCreateRetargetCampaign = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const payload = {
            ...retargetCampaignPayload,
            campaign_title: retargetCampaignPayload?.campaign_title?.trim()
        }
        const res = await createCampaignApi(payload);
        if (res.status && res.data) {
            setSelectedWhatsAppCampaign(res.data[0]);
            showSuccess(`Retarget WhatsApp Campaign Created Successfully`)
            navigate(`/whatsappcampaign/createnewcampaign?campaign_id=${res.data[0].campaign_id}`);
        } else {
            handleError(res);
        }
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    const handleClickOnCancel = () => {
        setRetargetCampaignPayload((prevState) => ({
            "contact_list_id": selectedCampaign?.contact_list_id,
            "meta_integration_whatsapp_phone_number_id": selectedCampaign?.meta_integration_whatsapp_phone_number_id,
            "campaign_title": "",
            "flag_template": true,
            "flag_present_template": true,
            "retargeted_from_campaign_id": selectedCampaign?.campaign_id,
            "campaign_contact_filter_logic_operator": "AND",
            "campaign_contact_filter": prevState.campaign_contact_filter.map((filter) => {
                filter.campaign_contact_filter_type_data = [];
                return filter;
            }),
        }))
    }

    const onClickOfInfo = () => {
        setFlagContactListDialog(true);
    }

    const appliedFiltered = () => {
        return campaignExecutionStatusData?.filter((status) => retargetCampaignPayload.campaign_contact_filter.find((filter) => filter.campaign_contact_filter_type_name.toLowerCase() == "campaign execution status")?.campaign_contact_filter_type_data?.some((type) => type.campaign_contact_filter_unique_id == status.campaign_execution_status_id))
    }

    useEffect(() => {
        if (selectedWhatsAppCampaign) {
            let contacts = filteredRetargetContacts(selectedWhatsAppCampaign?.campaign_contact_assignment_data, appliedFiltered(), retargetCampaignPayload?.campaign_contact_filter_logic_operator)
            setFilteredExecutionStatusContacts(contacts)
        }
    }, [selectedWhatsAppCampaign, retargetCampaignPayload?.campaign_contact_filter, retargetCampaignPayload?.campaign_contact_filter_logic_operator])

    const tagIds = selectedWhatsAppCampaign?.campaign_contact_tag_filter.map((tag: contactTagFilterInterface) => {
        return tag.contact_tag_id;
    })

    return (
        <>
            <Grid container className={`${globalStyles.flexColumn} ${style.createWhatsappCampaignContainer} ${style.retargetDrawerPadding}`} gap={"8px"} >
                <Grid item>
                    <Grid container className={`${globalStyles.spaceAlignmentCenter}`}>
                        <Grid item>
                            <Typography className={`${style.followupCampaignTitle}`}>{`Follow Up Campaign for ${selectedWhatsAppCampaign?.campaign_title ?? ""}`}</Typography>
                        </Grid>
                        <Grid item className={`${globalStyles.displayFlexStyle}`}>
                            <CloseIcon className={`${globalStyles.clickable}`} onClick={() => setOpenRetargetDrawer(false)} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    {breakPoints.flagLaptopScreen &&
                        <Grid container justifyContent={"flex-end"}>
                            <Grid item>
                                <Grid container alignItems={"center"} gap={"5px"} className={`${globalStyles.clickable}`}>
                                    <img
                                        src={previewIcon}
                                        className={globalStyles.previewIconStyle}
                                        alt=""
                                    />
                                    <Typography
                                        component={'span'}
                                        className={globalStyles.previewIconFont}
                                    >
                                        Preview
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    }

                    <Grid container>
                        <Grid item xs={12} className={style.createWhatsappCampaignContainer}>
                            <Grid container sx={{ justifyContent: "space-between" }} gap={{ xs: 0, lg: 1, xl: 2 }} flexWrap={"nowrap"} direction={{ xs: "column", lg: "row" }}>
                                <Grid item xs={12} lg={7.8} xl={7} p={1} className={style.whatsappCampaignLeftBox} mt={breakPoints.flagLargeScreen ? "40px" : "10px"} sx={{ height: `${innerHeight}px !important`, maxHeight: `${innerHeight}px !important`, position: "relative", overflow: "auto" }}>
                                    <Grid container>
                                        <Grid item xs={12} padding={"0px 5px 5px 0"}>
                                            <Grid container className={`${globalStyles.flexColumn}`} gap={"16px"}>

                                                <Grid item xs={12}>
                                                    <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                                        <Grid item xs={12}>
                                                            <Typography className={style.whatsappCampaignTitleTypography}>Follow Up Campaign Title <Required /></Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                placeholder='Enter Follow Up Campaign Title'
                                                                className={`${style.whatsappCampaignTextField} ${globalStyles.fullwidth}`}
                                                                value={retargetCampaignPayload.campaign_title || ""}
                                                                onChange={(e) => {
                                                                    setRetargetCampaignPayload((prevState) => ({
                                                                        ...prevState,
                                                                        campaign_title: e.target.value,
                                                                    }))
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                                        <Grid item xs={12}>
                                                            <Typography className={style.whatsappCampaignTitleTypography}>Logic <Required /></Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <RadioGroup
                                                                aria-labelledby="demo-radio-buttons-group-label"
                                                                name="radio-buttons-group"
                                                                className={style.templateRadioButtons}
                                                                value={retargetCampaignPayload.campaign_contact_filter_logic_operator}
                                                            >
                                                                <FormControlLabel
                                                                    value="AND"
                                                                    control={<Radio color='secondary' disableRipple />}
                                                                    label="AND"
                                                                    onChange={(e) => {
                                                                        setRetargetCampaignPayload((prevState) => ({
                                                                            ...prevState,
                                                                            campaign_contact_filter_logic_operator: "AND",
                                                                        }))
                                                                    }}
                                                                />
                                                                <FormControlLabel
                                                                    value="OR"
                                                                    control={<Radio color='secondary' disableRipple />}
                                                                    label="OR"
                                                                    onChange={(e) => {
                                                                        setRetargetCampaignPayload((prevState) => ({
                                                                            ...prevState,
                                                                            campaign_contact_filter_logic_operator: "OR",
                                                                        }))
                                                                    }}
                                                                />
                                                            </RadioGroup>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                                        <Grid item xs={12}>
                                                            <Typography className={style.whatsappCampaignTitleTypography}>Filter by Campaign Execution Status <Required /></Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Autocomplete
                                                                className={style.whatsappCampaignDropDowns}
                                                                multiple
                                                                options={campaignExecutionStatusData?.filter((executionStatus) => allowedExecutionContactStatus.includes(executionStatus.campaign_execution_status_name)) || []}
                                                                getOptionLabel={(option) => option.campaign_execution_status_name || ""}
                                                                value={campaignExecutionStatusData?.filter((status) => retargetCampaignPayload.campaign_contact_filter.find((filter) => filter.campaign_contact_filter_type_name.toLowerCase() == "campaign execution status")?.campaign_contact_filter_type_data?.some((type) => type.campaign_contact_filter_unique_id == status.campaign_execution_status_id)) || []}
                                                                onChange={(e, value: campaignExecutionStatusData[]) => { onChangeOfExecutionStatus(value); }}
                                                                renderInput={params => {
                                                                    const { InputProps, ...restParams } = params;
                                                                    const { startAdornment, ...restInputProps } = InputProps;
                                                                    return (
                                                                        <TextField
                                                                            {...restParams}
                                                                            placeholder='Select Campaign Execution Status'
                                                                            InputProps={{
                                                                                ...restInputProps,
                                                                                startAdornment: (
                                                                                    <div className={contactStyles.selectTagTextField}>
                                                                                        {startAdornment}
                                                                                    </div>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    );
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Grid container className={style.campaignSelectedContactBox} direction={"column"} gap={"10px"}>
                                                        <Grid item>
                                                            <Grid container direction={"column"} gap={"2px"}>
                                                                <Grid item>
                                                                    <Typography className={style.selectedContactsTitle}>Filtered Contacts</Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Grid container alignItems={"center"} gap={1}>
                                                                        <Grid item>
                                                                            <Typography className={style.selectedContactValue}>
                                                                                {`${filteredExecutionStatusContacts?.length || 0} Contacts`}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item
                                                                            sx={{ display: "flex", cursor: "pointer" }}
                                                                            onClick={() => { onClickOfInfo() }}
                                                                        >
                                                                            <IconsColor fillColor={primaryColor} iconName="info" height={"18"} width={"18"} />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Grid container className={`${globalStyles.flexColumn}`} gap={"10px"}>
                                                        <Grid item xs={12}>
                                                            <Typography className={style.whatsappCampaignTitleTypography}>Template <Required /></Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <RadioGroup
                                                                aria-labelledby="demo-radio-buttons-group-label"
                                                                name="radio-buttons-group"
                                                                value={retargetCampaignPayload.flag_present_template}
                                                                className={style.templateRadioButtons}
                                                            >
                                                                <FormControlLabel
                                                                    value={true}
                                                                    control={<Radio color='secondary' disableRipple />}
                                                                    label="Current Template"
                                                                    onChange={(e) => {
                                                                        setRetargetCampaignPayload((prevState) => ({
                                                                            ...prevState,
                                                                            flag_present_template: true,
                                                                        }));
                                                                        if (messageTemplateDetail) {
                                                                            //@ts-ignore
                                                                            setCreateTemplatePayload(updateValueOfCreateTemplatePayload(messageTemplateDetail))
                                                                        }
                                                                    }} />
                                                                <FormControlLabel
                                                                    value={false}
                                                                    control={<Radio color='secondary' disableRipple />}
                                                                    label="New Template"
                                                                    onChange={(e) => {
                                                                        setRetargetCampaignPayload((prevState) => ({
                                                                            ...prevState,
                                                                            flag_present_template: false,
                                                                        }))
                                                                        setCreateTemplatePayload(defaultCreateTemplatePayload(templateCategoryList ?? []))
                                                                    }}
                                                                />
                                                            </RadioGroup>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} className={style.whatsappCampaignButtonGrid}>
                                    <Grid container gap={"12px"} justifyContent={"start"} alignItems={"center"}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText={"Cancel"}
                                                sx={{ width: breakPoints.flagTabletScreen ? "100px" : "140px" }}
                                                className='borderedButtonStyle'
                                                onClick={() => handleClickOnCancel()}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText={"Create"}
                                                sx={{ width: breakPoints.flagTabletScreen ? "100px" : "140px" }}
                                                disabled={checkDisableCreateButton()}
                                                className='primaryButtonStyle'
                                                onClick={() => handleCreateRetargetCampaign()}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {!breakPoints.flagLaptopScreen &&
                                    <Grid item xs={12} lg={4} xl={4.5}>
                                        <Grid container className={`${globalStyles.flexColumn}`} justifyContent={"center"}>
                                            <Grid item>
                                                <BasicTemplatePreview metaInformation={createTemplatePayload} flagCampaign={true} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                            </Grid>
                        </Grid>
                    </Grid>

                    <GlobalPopUp
                        open={flagContactListDialog}
                        onClose={() => { setFlagContactListDialog(false); }}
                        handleClose={() => { setFlagContactListDialog(false); }}
                        flagShowCloseIcon={true}
                        borderRadius='10px'
                        paperMinWidth='60%'
                        paperMaxwidth='90%'
                        titlePadding='0px'
                    >
                        <RetargetedContactTable tagIds={tagIds || []} contact_list_id={selectedWhatsAppCampaign?.contact_list_id || 0} contact_filter={filteredExecutionStatusContacts || []} />
                    </GlobalPopUp>

                </Grid>
            </Grid>
        </>
    )
}

export default RetargetDrawer
